import { NgModule } from 'ng-metadata/core';
import { ProductOptionsComponent } from './product-options.component';

@NgModule({
  declarations: [ProductOptionsComponent],
})
export class ProductOptionsModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/common/product-options/product-options.module.ts